import { debounce } from "es-toolkit";
import { visuallyHiddenStyles } from "../components/visuallyHidden/VisuallyHidden.js";
const A11Y_ANNOUNCEMENT_ID = 'templafy-a11y-announcer';
const ANNOUNCEMENT_TIMEOUT = 500;
const debouncedClearAnnouncement = debounce(()=>{
    getA11YAnnouncerElement().textContent = '';
}, ANNOUNCEMENT_TIMEOUT);
const getA11YAnnouncerElement = ()=>{
    const existingA11YAnnouncer = document.querySelector(`#${A11Y_ANNOUNCEMENT_ID}`);
    if (existingA11YAnnouncer) return existingA11YAnnouncer;
    const newAnnouncerElement = document.createElement('div');
    newAnnouncerElement.setAttribute('id', A11Y_ANNOUNCEMENT_ID);
    newAnnouncerElement.setAttribute('role', 'status');
    newAnnouncerElement.setAttribute('aria-live', 'polite');
    newAnnouncerElement.setAttribute('aria-relevant', 'additions text');
    newAnnouncerElement.classList.add(visuallyHiddenStyles.visuallyHidden);
    document.body.append(newAnnouncerElement);
    return newAnnouncerElement;
};
const setA11YMessage = ({ message })=>{
    const announcement = getA11YAnnouncerElement();
    announcement.textContent = message;
    debouncedClearAnnouncement();
};
const debouncedSetA11yMessage = debounce(setA11YMessage, ANNOUNCEMENT_TIMEOUT);
const announceA11YMessage = (args)=>{
    getA11YAnnouncerElement();
    return debouncedSetA11yMessage(args);
};
export { announceA11YMessage };
